import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MARKET_NOTICE } from '../config/content';
import { findMarket, goToMarket, hrefFor } from '../utils/marketSwitch';
import styles from './MarketNotice.module.css';

/**
 * A one-line notice for visitors the edge geo-redirected here: it adds
 * ?<param>=<value> (e.g. ?from=au) when it does. Shown only on such a visit,
 * and only in a market whose content.ts defines MARKET_NOTICE; the link back
 * sets the market cookie first, like the footer switcher, so the edge does not
 * redirect the visitor again.
 */
const MarketNotice: React.FC = () => {
  const { pathname } = useLocation();
  // Read once: the query string is gone after the first in-app navigation,
  // but the notice stays until dismissed.
  const [visible, setVisible] = useState(() => {
    if (!MARKET_NOTICE) return false;
    try {
      return new URLSearchParams(window.location.search).get(MARKET_NOTICE.param) === MARKET_NOTICE.value;
    } catch {
      return false;
    }
  });

  const target = MARKET_NOTICE ? findMarket(MARKET_NOTICE.target) : undefined;
  if (!visible || !MARKET_NOTICE || !target) return null;
  const href = hrefFor(target, pathname);

  return (
    <div className={styles.notice} role="status">
      <span className={styles.text}>
        {MARKET_NOTICE.text}{' '}
        {MARKET_NOTICE.linkPrefix}{' '}
        <a href={href} hrefLang={target.hreflang} className={styles.link} onClick={(e) => goToMarket(e, target, href)}>
          <span aria-hidden="true">{'→'} </span>
          {MARKET_NOTICE.linkLabel}
        </a>
      </span>
      <button
        type="button"
        className={styles.close}
        onClick={() => setVisible(false)}
        aria-label={MARKET_NOTICE.dismissLabel}
      >
        {'×'}
      </button>
    </div>
  );
};

export default MarketNotice;
